export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-path/index.js
// module id = ../../../../d3-path/index.js
// module chunks = vendor